<template>
  <div>
    <Title :pages="[{ icon: 'truck', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <ModalFactura
        :button_name="$t('Crear') + ' ' + modal_title"
        :modal_title="modal_title"
        :formBtn="formBtn"
        :dialog="dialog_facturas"
        :parent="parent"
        :service="service"
        @updateDialog="closeModal"
        @loadList="loadList(service)"
        :item="mainItem"
        @updateItem="
          (newItem) => {
            mainItem = newItem;
          }
        "
        :validator="$validator"        
      />

      <v-card>
        <div class="row mb-5 mt-0">
          <div class="col-md-12" v-if="list_access">
            <div class="col-md-12" style="background:white; elevation-0">
              <div class="row pt-5">                                           
                <div class="col-md-3 pt-0">
                  <v-text-field v-model="house_bl_selected" autocomplete="off" data-vv-as="house_bl" name="house_bl" label="HAWB" class="pt-0 mt-0"></v-text-field>
                </div>
                <div class="col-md-3 pt-0">
                  <v-text-field v-model="master_bl_selected" autocomplete="off" data-vv-as="master_bl" name="master_bl" label="MAWB" class="pt-0 mt-0"></v-text-field>
                </div>                
                <div class="col-md-3 pt-0">
                  <v-text-field v-model="factura_agente_selected" autocomplete="off" data-vv-as="factura_agente" name="factura" label="Invoice Nº" class="pt-0 mt-0"></v-text-field>
                </div>               

                <div class="col-md-10 pt-0"></div>
                <div class="col-md-2 pt-0" style="display: flex;justify-content: end;">
                  <!--<v-btn color="error" class="mr-2" @click="export_filter">Exportar</v-btn>-->
                  <v-btn color="info" class="" @click="filter">Search</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="list" :search="search" :loading="loading" loading-text="Loading..." hide-default-footer disable-pagination>
          <template v-slot:item="props">
            <tr :style="(!props.item.closed)?'':'color: #999'">              
              <td>{{ props.item.guia_hija }}</td>
              <td>{{ props.item.guia_madre }}</td>
              <td class="justify-content-center px-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="blue" class="mr-1" @click="cargarFactura(props.item, false)">
                      remove_red_eye
                    </v-icon>
                  </template>
                  <span>View</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="update_access && !props.item.closed" v-on="on" small color="green" class="mr-2" @click="cargarFactura(props.item, true)">
                      edit
                    </v-icon>
                  </template>
                  <span>Load/Edit Invoices</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Busqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" />
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/";
import { agenteAirInvoiceService } from "@/libs/ws/agenteAirInvoiceService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import Title from "@/components/Title.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import ModalFactura from "./ModalFactura.vue";
import RolMixin from "@/mixins/RolMixin.vue";

export default {
  components: { Title, ModalFactura, DialogDelete },
  mixins: [GenericMixin, RolMixin],
  RolMixin,
  data() {
    return {
      parent: this,
      service: agenteAirInvoiceService,
      page_title: "Air InvoiceS",
      modal_title: "Air Invoice",
      mainItem: {
        id: "",
        
      },
      defaultItem: null,
      headers: [        
        { text: "HAWB", align: "left", sortable: true, value: "guia_hija" },
        { text: "MAWB", align: "left", sortable: true, value: "guia_madre" },        
        { text: "Action", value: "", align: "center" },
      ],
      list: [],
      dialog_delete: false,
      search: "",
      loading: false,
      pagination: {
        rowsPerPage: 10,
      },      
      house_bl_selected: "",
      master_bl_selected: "",
      factura_agente_selected: "",
      dialog_facturas: false,
    };
  },
  mounted() {
    this.defaultItem = Object.assign({}, this.mainItem);
    this.filter();
  },
  methods: {
    deleteItemConfirm() {
      this.delete(this.service,this.getFilterParams());
      this.dialog_delete = false;
      this.loadList(this.service);
    },
    getFilterParams() {
      const param = {        
        guia_hija: this.house_bl_selected,        
        guia_madre: this.master_bl_selected,                
        factura_agente: this.factura_agente_selected,
      };
      return param;
    },
    filter() {
      this.loadList(this.service, this.getFilterParams());
    },
    cargarFactura(item, update = true){
      if(update){
        this.editedIndex = this.list.indexOf(item);
        this.viewdIndex = -1;
      }else{
        this.viewdIndex = this.list.indexOf(item);
        this.editedIndex = -1;
      }
            
      this.mainItem = JSON.parse(JSON.stringify(item));
      this.dialog_facturas = true;
    },
    closeModal() {
      this.dialog_facturas = false;
      this.mainItem = JSON.parse(JSON.stringify(this.defaultItem));      
    },
  },
};

// TODO agregar un boton de limpiar busqueda.
</script>
